import { useQuery } from 'react-query'
import { BASE_API_URL } from 'constants/env'
import { API_METHODS } from 'constants/api-methods'
import { apiHeaders } from 'utils/api-headers'
import { store } from 'index'
import { handleErrors } from 'utils/handle-errors'
import { usersQueryKeys } from 'utils/query-keys'

interface ApiParams {
  page?: number
  perPage?: number
  filter?: 'all' | 'no_response' | 'response' | 'issues'
}

const fetchUserChats = async (userId: string, params: ApiParams = {}) => {
  const { page = 1, filter = 'all' } = params
  const perPage = params.perPage || 50

  // Build query parameters
  const queryParams = new URLSearchParams({
    user_id: userId,
    page: page.toString(),
    per_page: perPage.toString(),
  })

  // Add filter parameter only if it's not 'all'
  if (filter !== 'all') {
    queryParams.append('filter', filter)
  }

  let response = await fetch(
    `${BASE_API_URL}/admin/api/v2/chats?${queryParams.toString()}`,
    {
      method: API_METHODS.GET,
      headers: apiHeaders(store.getState()),
    }
  )
  response = handleErrors(response)
  return response.json()
}

const useUserChats = (userId: string, params: ApiParams = {}) => {
  return useQuery(
    [
      ...usersQueryKeys.all,
      userId,
      'chats',
      params.page || 1,
      params.perPage || 50,
      params.filter || 'all',
    ],
    () => fetchUserChats(userId, params),
    {
      enabled: !!userId,
      keepPreviousData: false,
    }
  )
}

export default useUserChats
